// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, object, string } from 'prop-types'
import Checkbox from './Checkbox'
import { UpdatedCheckboxGroupWrapper } from './styles'

// NOTE - this updated version does not offer label or errors support.
// This is intended to create a separation of interest for this component
// as we have various use cases to have a radio group with out the need for
// such things and it makes handling grid styles much easier this way.

// NOTE - this does not extend from UpdatedInputBase because handling
// values and their changes is unique in a checkbox group (supports one to many values)
// vs a text input or radio button which is a single value.

class UpdatedCheckboxGroup extends React.Component {
  static propTypes = {
    className: string,
    disabled: bool,
    idRoot: string.isRequired,
    input: object.isRequired,
    meta: object.isRequired,
    onChangeCustom: func,
    options: array.isRequired,
  }

  static defaultProps = {
    className: '',
  }

  // redux-form includes an onBlur handler here which we do not want.
  // this overrides that behavior allowing us to custom handle this
  // field value and how it changes.
  handleBlur = () => false

  handleChange = e => {
    const { value } = e.target

    const {
      input,
      onChangeCustom,
    } = this.props

    if (onChangeCustom) {
      return onChangeCustom(e, input.onChange)
    }

    return input.onChange(
      input.value.includes(value)
        // if the checkbox is now 'checked', then add it to input.value
        ? input.value.filter(v => v !== value)
        // else remove it from input.value
        : [...input.value, value]
    )
  }

  render () {
    const {
      className,
      disabled,
      idRoot,
      input,
      options,
    } = this.props

    return (
      <UpdatedCheckboxGroupWrapper className={`updated-checkbox-group ${className}`}>
        {options.map(o => (
          <Checkbox
            key={`${idRoot}-${o.value}`}
            {...input}
            {...o}
            checked={input.value.includes(o.value)}
            disabled={disabled}
            id={`${idRoot}-${o.value}`}
            onBlur={this.handleBlur}
            onChange={this.handleChange} />
        ))}
      </UpdatedCheckboxGroupWrapper>
    )
  }
}

export default UpdatedCheckboxGroup
